var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { connect } from '@/overmind';
import { hasNewInfosetsPage } from '@/shared/utils/helpers';
import InfosetsReborn from '@/pages/InfosetsReborn.vue';
import InfosetsLegacy from '@/pages/InfosetsLegacy.vue';
import { mixpanelTracking } from '@/services/mixpanel';
let Infosets = class Infosets extends Vue {
    /** Fallback no vue-auth cobre o render antes de o overmind hidratar. */
    get sessionUser() {
        const stateUser = this.currentUser;
        // Sem optional chaining: o ts-loader/webpack desta config nao parseia `?.`
        const auth = Vue.auth;
        const authUser = auth && typeof auth.user === 'function' ? auth.user() : null;
        return stateUser && Object.keys(stateUser).length > 0 ? stateUser : authUser;
    }
    get hasNewInfosets() {
        return hasNewInfosetsPage(this.sessionUser);
    }
    mounted() {
        mixpanelTracking('minhas listas: Acessou minhas listas');
    }
};
Infosets = __decorate([
    Component(connect(({ state }) => ({
        currentUser: state.users.currentUser,
    }), {
        name: 'Infosets',
        components: { InfosetsReborn, InfosetsLegacy },
    }))
], Infosets);
export default Infosets;
